/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';
    
    declare type InfiniteScrollDirectiveFactoryCb = () => InfiniteScrollDirective;

    interface IInfiniteScrollDirectiveScope extends ng.IScope {
        infiniteScroll: string;
    }

    export class InfiniteScrollDirective implements ng.IDirective {
        public static $name: string = 'infiniteScroll';
        public static $inject: string[] = [];

        public link: (scope: ng.IScope, element: JQuery, attribute: IInfiniteScrollDirectiveScope) => void;

        /**
         * Factory for the directive
         */
        public static Factory(): InfiniteScrollDirectiveFactoryCb {
            let directive: InfiniteScrollDirectiveFactoryCb = () => {
                return new InfiniteScrollDirective();
            };
            return directive;
        }

        /**
         * Constructor
         */
        constructor() {
            InfiniteScrollDirective.prototype.link = (scope: ng.IScope, element: JQuery, attribute: IInfiniteScrollDirectiveScope) => {
                let raw = element[0];
                element.on('scroll', function() {
                    if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight - 100) {
                        scope.$apply(attribute.infiniteScroll);
                    }
                });
            };
        }
    }
}